export default __webpack_public_path__ + "media/images/ui-bg_highlight-soft_100_deedf7_1x100-e2c1c901257e4a4a536896d3b09a28c1.png";